import { render, staticRenderFns } from "./TemplateHtmlToImage.vue?vue&type=template&id=2f22706e&scoped=true&"
import script from "./TemplateHtmlToImage.vue?vue&type=script&lang=js&"
export * from "./TemplateHtmlToImage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateHtmlToImage.vue?vue&type=style&index=0&id=2f22706e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22706e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
